export enum urlApp {
  // APIURL = Tconfig,
  APIURL = 'https://apis.fplatform.fincorp.vn/web/v1/', //#dev
  // # APIURL = "https://funds-api-uat.pvcomcapital.com.vn/v1/" //#//uat
  // # APIURL = "https://funds-api.pvcomcapital.com.vn/v1/"   //#live
}
